export default "__VITE_ASSET__DPAwR8as__"